import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useLanguage } from '../context/LanguageContext';
import { toast } from 'sonner';
import { Loader2, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter/subscribe`, { email });
      if (data.already_subscribed) {
        toast.info(t("You're already subscribed", 'Ya estás suscrito'));
      } else {
        toast.success(t('Thanks for subscribing!', '¡Gracias por suscribirte!'));
      }
      setDone(true);
    } catch (err) {
      toast.error(t('Invalid email', 'Correo inválido'));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        className="flex items-center gap-2 text-gold-400 font-lato text-sm"
        data-testid="newsletter-done"
      >
        <Mail className="w-4 h-4" />
        {t('You\'re on the list — see you in the inbox.', 'Estás en la lista — nos vemos en tu bandeja.')}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="newsletter-form">
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('Your email', 'Tu correo')}
        className="bg-white/10 border-white/20 text-white placeholder:text-gray-400"
        data-testid="newsletter-email"
      />
      <Button
        type="submit"
        disabled={loading}
        className="bg-gold-500 hover:bg-gold-600 text-white font-lato uppercase tracking-wider text-xs"
        data-testid="newsletter-submit"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t('Join', 'Unirme')}
      </Button>
    </form>
  );
}
